export default process.env.REACT_APP_ENDPOINT_LAMBDA_STRIPE_PAYMENT;
